import { createReducer } from 'helpers/redux';
import {
  SET_INITIALISED,
  SET_AWAITING_CALCULATION,
  SET_DATA,
  SET_ERROR,
  SET_STEP,
  SET_FINANCE_OPTION,
  SET_FORM_VALUES,
  SET_MAKES,
  SET_DEALERS,
  SET_SUBSTEP,
  SET_LOADED_CONFIGURATION,
  SET_CALCULATIONS,
  SET_FINANCE_PROVIDER_URL,
} from './types';

export const initialState = {
  initialised: false,
  data: {
    labels: {},
  },
  loading: true,
  awaitingCalculation: false,
  step: 0,
  subStep: 'a',
  completedSteps: [],
  form: {
    financeOption: null,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    partExchange: 'no',
    make: '',
    model: '',
    registration: '',
    mileage: '',
    condition: '',
  },
  makes: [],
  dealers: [],
  configuration: null,
  calculations: null,
};

const appReducer = createReducer({
  initialState,
  reducers: {
    [SET_INITIALISED]: state => ({
      ...state,
      initialised: true,
      loading: false,
    }),
    [SET_AWAITING_CALCULATION]: (state, { payload }) => ({
      ...state,
      awaitingCalculation: payload,
    }),
    [SET_DATA]: (state, { payload: data }) => {
      const { financeOptions } = data.financeOption;
      const lsFinanceProductName = window.localStorage.getItem('quoteProductName');
      const lsCalcOpened = JSON.parse(window.localStorage.getItem('calcOpened') || 'false');
      const productNameExists = financeOptions.find(
        financeOption => financeOption.financeProductName === lsFinanceProductName
      );

      return {
        ...state,
        data: {
          ...data,
          labels: {
            ...data.labels,
            ...data.financeOption.content,
            ...data.customerDetails.content,
            ...data.dealerDetails.content,
            ...data.dealerDetails.consent,
            ...data.summary.content,
          },
        },
        form: {
          ...state.form,
          financeOption: data.financeOption.financeOptions.find(financeOption =>
            lsFinanceProductName && productNameExists && lsCalcOpened
              ? financeOption.financeProductName === lsFinanceProductName
              : financeOption.default
          )?.id,
        },
      };
    },
    [SET_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
    }),
    [SET_STEP]: (state, { payload: step }) => ({
      ...state,
      step,
      completedSteps: state.completedSteps.includes(step) ? state.completedSteps : [...state.completedSteps, step],
    }),
    [SET_FINANCE_OPTION]: (state, action) => ({
      ...state,
      form: {
        ...state.form,
        financeOption: action.payload,
      },
    }),
    [SET_FORM_VALUES]: (state, action) => ({
      ...state,
      form: {
        ...state.form,
        ...action.payload,
      },
    }),
    [SET_MAKES]: (state, action) => ({
      ...state,
      makes: action.payload,
    }),
    [SET_DEALERS]: (state, action) => ({
      ...state,
      dealers: action.payload,
    }),
    [SET_SUBSTEP]: (state, action) => ({
      ...state,
      subStep: action.payload,
    }),
    [SET_LOADED_CONFIGURATION]: (state, action) => ({
      ...state,
      configuration: action.payload,
    }),
    [SET_CALCULATIONS]: (state, action) => ({
      ...state,
      calculations: action.payload,
    }),
    [SET_FINANCE_PROVIDER_URL]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        financeProviderUrl: action.payload,
      },
    }),
  },
});

export default appReducer;
